export const INIT_LOCATION = 'initLocation';
export const STRATEGY_CHANGED = 'STRATEGY_CHANGED';
